module.exports = __webpack_public_path__ + "static/lato-v14-latin-300-49d84f82f494aec8f63710fd2d55ba41.ttf";